// Stock cible et plancher d'achalandage d'une ouverture (articles), partagés par le réappro et le
// back-office, qui simule le stock cible pour un nombre de frigos.
// Spec : docs/superpowers/specs/2026-10-29-plancher-achalandage-ouverture-design.md.
export const OPENING_STOCK_TARGET_WITHOUT_FRIDGES = 1500
export const OPENING_STOCK_TARGET_MIN = 1400
export const OPENING_STOCK_TARGET_MAX = 1800
export const OPENING_STOCK_FLOOR = 1200

const FRIDGE_WIDTHS_M = { x: 1.25, y: 1.88, z: 2.55 }

export interface FridgeCounts {
  fridgeCountX: number | null
  fridgeCountY: number | null
  fridgeCountZ: number | null
}

export const fridgeLinearOf = (fridges: FridgeCounts | null): number | null => {
  if (fridges === null) return null
  const { fridgeCountX: x, fridgeCountY: y, fridgeCountZ: z } = fridges
  if (x === null && y === null && z === null) return null
  return FRIDGE_WIDTHS_M.x * (x ?? 0) + FRIDGE_WIDTHS_M.y * (y ?? 0) + FRIDGE_WIDTHS_M.z * (z ?? 0)
}

export const defaultOpeningStockTargetOf = (fridges: FridgeCounts | null): number => {
  const linear = fridgeLinearOf(fridges)
  if (linear === null || linear <= 0) return OPENING_STOCK_TARGET_WITHOUT_FRIDGES
  const target = Math.round(OPENING_STOCK_TARGET_MIN + 80 * (linear - 5))
  return Math.min(OPENING_STOCK_TARGET_MAX, Math.max(OPENING_STOCK_TARGET_MIN, target))
}
